import React, { memo } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ArrowRight, ArrowDown } from 'lucide-react';
export const UniqueMechanism: React.FC = () => {
  return <SectionWrapper data-id="element-161">
      <div className="bg-navy border-2 border-gold rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-162">
        {/* Subtle background accent */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none" data-id="element-163"></div>

        <h2 className="text-3xl md:text-4xl font-bold text-gold mb-6 text-center relative z-10" data-id="element-164">
          El Método MRA — Mecanismo de Respuesta de Anclaje
        </h2>

        <p className="text-lg md:text-xl text-white leading-relaxed mb-12 text-center max-w-3xl mx-auto relative z-10" data-id="element-165">
          No se trata de memorizar respuestas largas ni de impresionar al cónsul
          con documentos. El Método MRA te enseña a dar respuestas cortas,
          precisas y estratégicas que cierran el camino a las repreguntas y
          eliminan la sospecha desde tu primera frase.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 relative z-10" data-id="element-166">
          {/* Step 1 */}
          <div className="flex-1 flex flex-col items-center text-center" data-id="element-167">
            <div className="w-16 h-16 rounded-full bg-gold/10 border-2 border-gold flex items-center justify-center mb-4" data-id="element-168">
              <span className="text-3xl font-bold text-gold" data-id="element-169">1</span>
            </div>
            <p className="text-lg font-semibold text-white" data-id="element-170">
              Ancla tu respuesta en 10 palabras o menos
            </p>
          </div>

          {/* Arrow 1 */}
          <div className="hidden md:block text-gold/50" data-id="element-171">
            <ArrowRight size={40} data-id="element-172" />
          </div>
          <div className="block md:hidden text-gold/50 py-2" data-id="element-173">
            <ArrowDown size={32} data-id="element-174" />
          </div>

          {/* Step 2 */}
          <div className="flex-1 flex flex-col items-center text-center" data-id="element-175">
            <div className="w-16 h-16 rounded-full bg-gold/10 border-2 border-gold flex items-center justify-center mb-4" data-id="element-176">
              <span className="text-3xl font-bold text-gold" data-id="element-177">2</span>
            </div>
            <p className="text-lg font-semibold text-white" data-id="element-178">
              Proyecta certeza con tu postura y tono de voz
            </p>
          </div>

          {/* Arrow 2 */}
          <div className="hidden md:block text-gold/50" data-id="element-179">
            <ArrowRight size={40} data-id="element-180" />
          </div>
          <div className="block md:hidden text-gold/50 py-2" data-id="element-181">
            <ArrowDown size={32} data-id="element-182" />
          </div>

          {/* Step 3 */}
          <div className="flex-1 flex flex-col items-center text-center" data-id="element-183">
            <div className="w-16 h-16 rounded-full bg-gold/10 border-2 border-gold flex items-center justify-center mb-4" data-id="element-184">
              <span className="text-3xl font-bold text-gold" data-id="element-185">3</span>
            </div>
            <p className="text-lg font-semibold text-white" data-id="element-186">
              Cierra la pregunta antes de que el oficial dude
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};